import util from "../util";
import MenuObject from "./menu-object";
import Text from "./text";
import store from "../store";
import constants from '../constants';
import * as actions from "../actions";
import Matrix from "./matrix";
import $ from "jquery";
import { deleteFramePreview } from "./reposition-frame";
import {fixComponentLineHeight} from "./line-height";
import {rotateCursor} from "./component-resize";
import Renderer from "./renderer";
import Interactable from "./interactable";
import { pushSmartBit } from '../service/smartSaveService';
import { syncInGroup } from './menu-group';

export function getSelectBarsAndCorners(withRotate, full = false, onlySides = false, onlyCorners = false, onlyBottomRightCorner = false, onlySidesAndCorners = false) {
    let content = '';

    if (onlyBottomRightCorner) {
        content = `<div class="bars floater">
                    <span class="left"></span>
                    <span class="right"></span>
                    <span class="top"></span>
                    <span class="btm"></span>
                    <span class="drag-res btm-right"></span>`;
    } else if (onlySidesAndCorners) {
        content = `<div class="bars floater">
                    <span class="left"></span>
                    <span class="right"></span>
                    <span class="top"></span>
                    <span class="btm"></span>
                    <span class="drag-res res-left"></span>
                    <span class="drag-res res-right"></span>
                    <span class="drag-res btm-right"></span>
                    <span class="drag-res btm-left"></span>
                    <span class="drag-res top-right"></span>
                    <span class="drag-res top-left"></span>`;
    } else if (!onlySides) {
        content = `<div class="bars floater">
                    <span class="left"></span>
                    <span class="right"></span>
                    <span class="top"></span>
                    <span class="btm"></span>
                    <span class="drag-res btm-right"></span>
                    <span class="drag-res btm-left"></span>
                    <span class="drag-res top-right"></span>
                    <span class="drag-res top-left"></span>`;
    } else {
        content = `<div class="bars floater">
                    <span class="left"></span>
                    <span class="right"></span>
                    <span class="top"></span>
                    <span class="btm"></span>
                    <span class="drag-res res-left"></span>
                    <span class="drag-res res-right"></span>`;
    }

    if (full && !onlyBottomRightCorner && !onlyCorners) {
        content += `
            <span class="drag-res res-left"></span>
            <span class="drag-res res-right"></span>
            <span class="drag-res res-top"></span>
            <span class="drag-res res-btm"></span>
        `;
    }

    if (withRotate) {
        content += `<span class="rotate"><span class="bar"></span><span class="rotate-handler"><svg><use href="${constants.appPrefix + "/svg/icons.svg#app-sync"}"/></svg></span></span>`;
    }

    content += '</div>';
    return content;
}

function addToPageBars($element, content) {
    if ($element) {
        const $pageBars = $element.closest('.page').find('.page-bars');
        if ($element.parent('[data-component="group"]').length > 0) {
            $element = $element.parent();
        }
        const id = $element.attr('id');
        if ($pageBars.find(`div#${id}`).length > 0) {
            $pageBars.find(`div#${id}`).remove();
        }
        let newBars = $(content);
        newBars.attr('id', id);
        newBars.attr('page-component', $element.attr('data-component'));
        newBars.addClass('page-bar');
        setBarsStyle(newBars, $element);
        $pageBars.append(newBars);

        const $page = $element.closest('.page');
        $('.page').each(function() {
            const $this = $(this);
            if ($this.attr('id') === $page.attr('id')) {
                $this.css('z-index', '11');
            } else {
                $this.css('z-index', '');
            }
        })
    }
}

export function updatePageBars($element) {
    if ($element.parent('[data-component="group"]').length > 0) {
        $element = $element.parent();
    }
    const $elementBars = $element.closest('.page').find(`.page-bars #${$element.attr('id')}`);
    if ($elementBars.length > 0) {
        setBarsStyle($elementBars, $element);
    }
}

export function setBarsStyle($elementBars, $element) {
    ['left', 'top', 'width', 'height', 'transform', 'transform-origin'].forEach(function(attr) {
        $elementBars.css(attr, $element.css(attr));
    });
    if (util.isText($element)) $elementBars.css('height', $element.outerHeight());

    const htmlEl = $element[0];
    const selectionHeight = htmlEl.getBoundingClientRect().height;

    [$elementBars, $element].forEach($el => {
        if ($el.length) {
            const $kids = $el.find('.res-left, .btm-left, .btm-right, .top-right');
            if (selectionHeight < 40) {
                $kids.hide();
            } else {
                $kids.show();
            }
        }
    });
}

export function removePageBars($element=null) {
    if ($element) {
        const $elementBars = $element.closest('.page').find(`.page-bars #${$element.attr('id')}`);
        $elementBars.remove();
    } else {
        $('.pages .page-bars .bars').remove();
    }
}

export function getLockedSelectBars(isMenuObject) {
    return `<div class="bars floater locked">
            <span class="left"></span>
            <span class="right"></span>
            <span class="top"></span>
            <span class="btm"></span>
            ${isMenuObject && store.getState().isMobileVersion ? `<span class="edit-mo"><svg><use xlink:href="${constants.appPrefix + "/svg/icons.svg#app-icon-edit"}" /></svg></span>` : ''}
           </div>`;
    // return '';
}

export function getSelectBarsAndSides(withSides = true, withRotate = false) {
    //return '';
    return `<div class="bars floater">
        <span class="left"></span>
        <span class="right"></span>
        <span class="top"></span>
        <span class="btm"></span>
        ${ withSides ? `<span class="drag-res res-left"></span><span class="drag-res res-right"></span>` : '' }
        ${ withRotate ? `<span class="rotate"><span class="bar"></span><span class="rotate-handler"><svg><use href="${constants.appPrefix + "/svg/icons.svg#app-sync"}"/></svg></span></span>` : '' }
    </div>`;
}

export function select($element, fake, contentEditable = true, comesFromMultiSelect = false) {
    // if (!!store.getState().$element && MenuObject.isMenuObject(store.getState().$element)) {
    //     syncInGroup(store.getState().$element, store.getState().menuGroups);
    // }

    if ($element.hasClass('page-hover')) {
        $element = $element.closest('.page').find(`.content #${$element.attr('object-id')}`);
    }
    $element.css('max-width', '');
    util.hideDropdown();

    const width = $element.width();
    const height = $element.height();
    const onlyBottomRightCorner = width < 40 && height < 40;
    const wasAlreadySelected = util.isSelected($element) && !comesFromMultiSelect;
    const $barsHost = $element;
    $barsHost.find('.bars').remove();

    $element.addClass(fake ? 'fake-in-focus' : 'in-focus');
    if (!fake) $element.removeClass('fake-in-focus');

    if ($element.attr('data-component') === 'frame-preview') {
        let content = getSelectBarsAndCorners(false, true, false, true, onlyBottomRightCorner);
        $barsHost.append(content);
        addToPageBars($element, content);
    }

    if ( store.getState().isMobileVersion && util.isQrCode($element) && util.isQRFrameEmpty($element)) {
        store.dispatch(actions.setIsMobileAside(true));
        setTimeout(() => { store.dispatch(actions.goToView('qr-codes')); });
    }

    if (util.isText($element)) {
        if (!fake && !wasAlreadySelected) {
            fixComponentLineHeight($element);
            Text.startEditMode($element, contentEditable);
        }
    }

    if ($element.attr('data-component') !== 'frame-preview') {
        deleteFramePreview();
    }

    $('.bars.floater .drag-res').on('mouseover', function(e) {
        rotateCursor(e);
    });

    setTimeout(() => {
        Interactable.createMultiinteractable();
    }, 100);
}

export function deselectMultiSelection($keep) {
    store.getState().$elements.forEach(($it) => {
        if ($it.attr('id') !== $keep.attr('id')) {
            deselect($it)
        }
    });
    store.dispatch(actions.select($keep))
}

export function deselect($element) {
    $element.removeClass('in-focus fake-in-focus');
    const $barsHost = $element;
    $barsHost.find('.bars').remove();

    const id = $element.attr('id');
    $element.closest('.page').find(`.page-bars div#${id}`).remove();
    $('.bars.floater .drag-res').off('mouseover');

    const $group = $element.parents('.group');

    if (util.isText($element)) {
        Text.endEditMode($element);

        if (window.event && window.event.target !== $element.find('.txt')[0]) {
            Text.ensureTextSize($element);
            const $matrixElement = $group.length > 0 ? $group : $element;
            Matrix.update($matrixElement.attr('id'), {
                width: $matrixElement.width(),
                height: $matrixElement.height()
            });
        }

        if (store.getState().view === 'word-art') {
            store.dispatch(actions.setView('text-mo'));
            store.dispatch(actions.goToSubview('add-new'));
        }
    }

    if (util.isQrCode($element)) {
        util.highlightAsideQrs();
    }

    if (util.isFrame($element)) {
        store.dispatch(actions.setReplaceFrameMode(false));
    }

    if (store.getState().view === 'animations') {
        store.dispatch(actions.setView('text-mo'));
        store.dispatch(actions.goToSubview('add-new'));
    }

    if ($group.length > 0) {
        $group.removeClass('in-focus fake-in-focus');
        $barsHost.find('.bars').remove();
    }

    // pushSmartBit({
    //     id: $element.attr("id"),
    //     content: $element.html()
    // })

    setTimeout(() => {
        Interactable.createMultiinteractable();
    }, 100);
}

export function reselect() {
    const $inFocus = $('#canvas').find('.in-focus');
    if ($inFocus.length === 0) return;

    deselectAll();
    $inFocus.click();
}

export function deselectAll(removePreviews = true) {
    $("#canvas").find(".in-focus, .fake-in-focus").each(function () {
        deselect($(this));
    });
    store.dispatch(actions.setReplaceFrameMode(false));

    if (store.getState().view === 'color-picker') {
        store.dispatch(actions.setView('graphics'));
    }

    setTimeout(() => {
        Interactable.clearMultiinteractable();
    }, 100);
}
